
import Cookies from 'js-cookie';
export const cookieLangName = 'hvclang';
export const setCookie = (key: string, value: string, options?: Cookies.CookieAttributes) => {
  Cookies.set(key, value, options);
};
export const getCookie = (key: string) => {
  return Cookies.get(key);
};
export const removeCookie = (key: string) => {
  Cookies.remove(key);
};
export const getLang = (): string=>{
  const language = getCookie(cookieLangName) || 'vn'
  return language
}